import { MutableRefObject, useEffect, useRef } from "react";

import useSetState from "./useSetState";

type StateType = Record<string, any>;

const useSafeSetState = (initialValue: StateType) => {
  const [state, setState] = useSetState(initialValue);
  const mountedRef: MutableRefObject<any> = useRef(false);
  useEffect(() => {
    mountedRef.current = true;
    return function cleanup() {
      mountedRef.current = false;
    };
  }, []);
  const safeSetState = (...args: Array<any>) =>
    mountedRef.current && setState(...args);

  return [state, safeSetState];
};

export default useSafeSetState;
